import { StartHOC } from 'testania';
import { ComponentType } from 'react';

import { useAnalytic } from 'services/Analytics/useAnalytic';

import usePreloadNextPage from 'hooks/usePreloadNextPage';

import { ICommonPageProps } from 'types/pages/startPages/commonTypes';

function withStartHOC<T extends ICommonPageProps>(Component: ComponentType<T>) {
    const WrappedComponent = (props: T) => {
        const { getNextPage } = props;

        useAnalytic();
        usePreloadNextPage({ getNextPage });

        return <Component {...props} />;
    };

    WrappedComponent.displayName = `withStartHOC(${Component.displayName})`;

    return StartHOC(WrappedComponent);
}

export default withStartHOC;
